import { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import { evRecommendationClick, evRecommendationImpressionWrapper } from 'events/recommendations';
import { trackEvent } from 'helpers/analytics';
import MelodyCardProduct from 'components/common/melodyCard/MelodyCardProduct';
import { track } from 'apis/amethyst';

import styles from 'styles/components/search/inlineRecos.scss';

const SearchInlineRecos = ({ inlineRecos, onHeartClick, showHearting, hearts, msaImageParams, showRatingStars, heartsList, heartsData, searchTerm }, { testId }) => {
  const additionalMelodyCardProductClasses = { container: styles.reco };

  const handleInlineRecoClick = useCallback(({ index, styleId, productId }) => {
    trackEvent('TE_SEARCH_INLINE_RECO_CLICK', `styleId:${styleId}productIndex:${index}:searchTerm:${searchTerm}`);
    track(() => ([
      evRecommendationClick, {
        index: index + 1,
        recommendationType: 'PRODUCT_RECOMMENDATION',
        recommendationValue: productId,
        recommendationSource: 'EP13N',
        widgetType: 'SIMILAR_PRODUCT_WIDGET'
      }
    ]));
  }, [searchTerm]);

  useEffect(() => {
    const styleIds = inlineRecos.recos.map(reco => reco.styleId);
    trackEvent('TE_SEARCH_INLINE_RECOS_VIEW', `styles:${styleIds}:searchTerm:${searchTerm}`);
    const recommendationImpression = [{
      numberOfRecommendations: styleIds.length,
      recommendationType: 'PRODUCT_RECOMMENDATION',
      recommendationSource: 'EP13N',
      widgetType: 'SIMILAR_PRODUCT_WIDGET'
    }];
    track(() => ([ evRecommendationImpressionWrapper, { recommendationImpression } ]));
  }, [inlineRecos, searchTerm]);

  return (
    <aside className={styles.searchHorizontalRecosContainer} data-reco-count={inlineRecos.recos.length}>
      <h2>{inlineRecos.title}</h2>
      <div className={styles.products}>
        {inlineRecos.recos.map((reco, index) => {
          const { styleId, productId } = reco;
          return (
            <MelodyCardProduct
              key={`${productId}-${styleId}`}
              componentStyle="searchProductInlineRecos"
              onComponentClick={() => handleInlineRecoClick({ index, styleId, productId })}
              showFavoriteHeart={showHearting}
              onHeartClick={onHeartClick}
              hearts={hearts}
              additionalClasses={additionalMelodyCardProductClasses}
              cardData={reco}
              msaImageParams={msaImageParams}
              melodyCardTestId={testId('searchResultInlineReco')}
              showRatingStars={showRatingStars}
              heartsList={heartsList}
              heartsData={heartsData}
            />
          );
        }
        )}
      </div>
    </aside>
  );
};

SearchInlineRecos.contextTypes = {
  testId: PropTypes.func
};

export default SearchInlineRecos;
